// extracted by mini-css-extract-plugin
export default {"mainWrapper":"shipper-container_mainWrapper__xGSyB","boxWrapper":"shipper-container_boxWrapper__43WwN"};